import { render, staticRenderFns } from "./ProductConstrnClsReview.vue?vue&type=template&id=edbf2ed4&"
import script from "./ProductConstrnClsReview.vue?vue&type=script&lang=js&"
export * from "./ProductConstrnClsReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductConstrnClsReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductConstrnClsReview.vue"
export default component.exports